import React, { useState, FunctionComponent, useEffect } from 'react';

import { RootState } from "../../../store";
import { useSelector } from "react-redux";

export interface ToggleSwitchProps {
    defaultChecked: boolean;
    onToggle: (checked: boolean) => void;
}

const ToggleSwitch: FunctionComponent<ToggleSwitchProps> = ({ defaultChecked, onToggle }) => {
  const [isChecked, setIsChecked] = useState(defaultChecked);

  const uiData = useSelector((state: RootState) => state.ui);

  useEffect(() => {
    setIsChecked(defaultChecked);
  }, [defaultChecked]);

  const handleChange = () => {
    const newChecked = !isChecked;
    setIsChecked(newChecked);
    onToggle(newChecked);
  };

  return (
    <label className="relative inline-block cursor-pointer" style={{ width: "3.25vw", height: "2.35vh" }}>
      <input
        type="checkbox"
        checked={isChecked}
        onChange={handleChange}
        className="opacity-0 w-0 h-0"
      />
      <span
        className="absolute inset-0 transition-all duration-500 ease-in-out"
        style={{
          backgroundColor: isChecked ? `rgba(${uiData.schemeColor}, 0.9)` : `rgba(${uiData.schemeColor}, 0.5)`,
          borderRadius: "1vh",
          filter: "drop-shadow(0vh 0vh 0.2vh rgba(0, 0, 0, 1))",
        }}
      >
        <span
          className="absolute transition-transform duration-500 ease-in-out rounded-full bg-gray-800/70"
          style={{
            height: "2vh",
            width: "2vh",
            left: "0.2vw",
            bottom: "0.2vh",
            transform: isChecked ? "translateX(1.8vw)" : "translateX(0)",
          }}
        />
      </span>
    </label>
  );
};

export default ToggleSwitch;
